// Ontology — standalone AppOntology extraction (no IDE dependencies)

export type {
  AppOntology,
  OntologyDatasource,
  OntologyFlowNode,
  OntologyStateNode,
  OntologyUIBinding,
  OntologyEdge,
  OntologyNode,
  BlockInput,
} from './types'

export { extractAppOntology } from './extract-ontology'

export { ontologyToManifest } from './ontology-to-manifest'

export {
  buildCrossRefFromBlocks,
  type MinimalCrossRef,
  type FlowUsageEntry,
  type ElementEventEntry,
  type StateUsageEntry,
  type NavigationEntry,
} from './extract-cross-ref'

export {
  buildOntologySystemPrompt,
  buildOntologySummary,
  type OntologySummary,
  type OntologyPromptOptions,
} from './ontology-context'

export { enrichAgentWithOntology } from './enrich-agent'

export { generateFallbackNarrative } from './narrative-fallback'
